if (!customElements.get('size-chart-popup')) {
    customElements.define(
      'size-chart-popup',
      class SizeChartPopup extends HTMLElement {
        constructor() {
          super();
          this.toggles = document.querySelectorAll('[href="#size-chart-toggle"]');
          this.sizeChart = this.querySelector('.size-chart-popup__container');
          this.toggleTables = this.querySelectorAll('[name="size-chart-toggle"]');
          this.tables = this.querySelectorAll('.size-chart-popup__table');
          this.accordionToggle = document.querySelector('[data-toggle-size-chart]');
        }
  
        connectedCallback() {
            this.toggles.forEach(toggle => {
                toggle.addEventListener('click', this.onTogglePopup.bind(this));
            });

            this.sizeChart.addEventListener('click', this.onClosePopup.bind(this));

            this.accordionToggle?.addEventListener('click', this.onClickAccordion.bind(this));
        }
        
        onClickAccordion(e) {
            e.preventDefault();
            this.sizeChart.classList.add('active');
        }

        onTogglePopup(e) {
            e.preventDefault();
            this.sizeChart.classList.toggle('active');
        }

        onClosePopup(e) {
            if(e.target.closest('.size-chart-popup__content')) return;
            this.sizeChart.classList.remove('active');
        }
      }
    );
  }
  